module.exports = __webpack_public_path__ + "static/media/loading.f4f5da82.gif";